// var rellax = new Rellax('.rellax', {
//     center: true,
//     wrapper: null,
//     round: true,
//     vertical: true,
//     horizontal: false
//   });
  window.onload=function(){
      var swiper1 = new Swiper(".mySwiper1", {
        slidesPerView: 4,
        spaceBetween: 31,
        centeredSlides: true,
        on: {
            slideChange: function () {
                if(this.isBeginning){
                  $(".m-lrCon5").find(".img1").addClass("op2");
                }else{
                  $(".m-lrCon5").find(".img1").removeClass("op2");
                }
                if(this.isEnd){
                  $(".m-lrCon5").find(".img2").addClass("op2");
                }else{
                  $(".m-lrCon5").find(".img2").removeClass("op2");
                }
            }
        }
      });
      $(".m-lrCon5").find(".img1").click(function () {
        swiper1.slidePrev();
      });
      $(".m-lrCon5").find(".img2").click(function () {
        swiper1.slideNext();
      });
      var swiper2 = new Swiper(".mySwiper2", {
        slidesPerView: 4,
        spaceBetween: 31,
        centeredSlides: true,
        on: {
            slideChange: function () {
                if(this.isBeginning){
                  $(".m-lrCon6").find(".img1").addClass("op2");
                }else{
                  $(".m-lrCon6").find(".img1").removeClass("op2");
                }
                if(this.isEnd){
                  $(".m-lrCon6").find(".img2").addClass("op2");
                }else{
                  $(".m-lrCon6").find(".img2").removeClass("op2");
                }
            }
        }
      });
      $(".m-lrCon6").find(".img1").click(function () {
        swiper2.slidePrev();
      });
      $(".m-lrCon6").find(".img2").click(function () {
        swiper2.slideNext();
      });
      var swiper = new Swiper(".m-mySwiper1", {
        slidesPerView: 2,
        spaceBetween: 16,
        centeredSlides: true,
        slidesPerView: 'auto',
        on: {
            slideChange: function () {
                if(this.isBeginning){
                  $(".m-lrCon1").find(".img1").addClass("op2");
                }else{
                  $(".m-lrCon1").find(".img1").removeClass("op2");
                }
                if(this.isEnd){
                  $(".m-lrCon1").find(".img2").addClass("op2");
                }else{
                  $(".m-lrCon1").find(".img2").removeClass("op2");
                }
            }
        }
      });
      var swiper = new Swiper(".m-mySwiper2", {
        slidesPerView: 2,
        spaceBetween: 16,
        centeredSlides: true,
        slidesPerView: 'auto',
        on: {
            slideChange: function () {
                if(this.isBeginning){
                  $(".m-lrCon2").find(".img1").addClass("op2");
                }else{
                  $(".m-lrCon2").find(".img1").removeClass("op2");
                }
                if(this.isEnd){
                  $(".m-lrCon2").find(".img2").addClass("op2");
                }else{
                  $(".m-lrCon2").find(".img2").removeClass("op2");
                }
            }
        }
      });
      var swiper = new Swiper(".m-mySwiper3", {
        slidesPerView: 2,
        spaceBetween: 16,
        centeredSlides: true,
        slidesPerView: 'auto',
        on: {
            slideChange: function () {
                if(this.isBeginning){
                  $(".m-lrCon3").find(".img1").addClass("op2");
                }else{
                  $(".m-lrCon3").find(".img1").removeClass("op2");
                }
                if(this.isEnd){
                  $(".m-lrCon3").find(".img2").addClass("op2");
                }else{
                  $(".m-lrCon3").find(".img2").removeClass("op2");
                }
            }
        }
      });
      var swiper = new Swiper(".m-mySwiper4", {
        slidesPerView: 2,
        spaceBetween: 16,
        centeredSlides: true,
        slidesPerView: 'auto',
        on: {
            slideChange: function () {
                if(this.isBeginning){
                  $(".m-lrCon4").find(".img1").addClass("op2");
                }else{
                  $(".m-lrCon4").find(".img1").removeClass("op2");
                }
                if(this.isEnd){
                  $(".m-lrCon4").find(".img2").addClass("op2");
                }else{
                  $(".m-lrCon4").find(".img2").removeClass("op2");
                }
            }
        }
      });
  }
  var swiper100 = new Swiper(".mySwiper100", {
    slidesPerView: 2,
    spaceBetween: 20,
    centeredSlides: false,
    slidesOffsetBefore: 32,
    slidesPerView: 'auto',
    on: {
        slideChange: function () {
            
        }
    }
  });
  getData100();
  function getData100(){
    $.ajax({ 
        url:'https://cdn.shopify.com/s/files/1/0817/0448/5170/files/glossary.json',
        method: 'GET', 
        success: function (res) {
          if(res.isShow){
            $("#listBottom").show();
            $(".bottomLikeCon").show();
          }else{
            $("#listBottom").hide();
            $(".bottomLikeCon").hide();
          }
          var funIconData=res.tabel1;
          console.log("111",funIconData);
          $.each(funIconData, function (index, data) {
            let html=`<div class="flexViewItem"><div class="imgCon2"><a href="${data.link}">
                          <img src="${data.imgUrl}" width="" height="">
                        </a>
                      </div>
                      <div class="newTextCon2">
                        <p class="p1">${data.isType}</p>
                        <p class="p2" title="${data.name}">${data.name}</p>
                        <p class="p3">${data.dec}</p>
                        <a href="${data.link}">LEARN MORE</a>
                      </div>
                    </div>`;
  
                $('.flexViewCon2').append(html);

              let html2=`<div class="swiper-slide swiper-slide100">
                        <a href="${data.link}">
                          <img src="${data.imgUrl}" width="" height="">
                        </a>
                        <div class="swTextCon">
                          <p class="p1">${data.isType}</p>
                          <p class="p2" title="${data.name}">${data.name}</p>
                          <p class="p3">${data.dec}</p>
                          <a class="learnA" href="${data.link}">LEARN MORE</a>
                        </div>
                      </div>`;
              $('.swiper-wrapper100').append(html2);
            });
            swiper100.update();

          
        },
        error: function (error) {
          console.log("222",error);
        }
    });
  }
  $('.hoverp').hover(
      function() {
          // 鼠标进入元素时触发
          $(this).addClass("active");
          var num=$(this).attr("data-num");
          if(num==1){
            $(".greenImg").hide();
            $(".green1").show();
          }
          // if(num==2){
          //   $(".greenImg").hide();
          //   $(".green2").show();
          // }
      },
      function() {
          // 鼠标离开元素时触发
          $(this).removeClass("active");
      }
  );
  $(".bgIcon1").click(function(){
    $(".bgIcon1").removeClass("op2");
    $(".bgIcon1").addClass("op1");
    $(".bgIcon2").removeClass("op1");
    $(".bgIcon3").removeClass("op1");
    $(".bgIcon2").addClass("op2");
    $(".bgIcon3").addClass("op2");
    $(".bigText").text("Fill Power (FP) is a key measure of the insulating performance of down. The higher the Fill Power, the better the quality of the down jacket. A Fill Power of 700FP indicates that one ounce (approximately 28.35 grams) of down occupies a space of 700 cubic inches. With the same amount of filling, it can fix a larger volume of air for insulation and heat retention. It is generally used for cold climates ranging from 0 to -10°C, offering an unrivaled warmth-to-weight ratio. It is suitable for extremely cold weather and outdoor activities such as skiing and mountaineering.")
  })
  $(".bgIcon2").click(function(){
    $(".bgIcon2").removeClass("op2");
    $(".bgIcon2").addClass("op1");
    $(".bgIcon1").removeClass("op1");
    $(".bgIcon3").removeClass("op1");
    $(".bgIcon1").addClass("op2");
    $(".bgIcon3").addClass("op2");
    $(".bigText").text("Fill Power (FP) is a crucial measure of the insulating capability of down. The higher the Fill Power, the better the quality of the down jacket. An 800FP rating means that one ounce (approximately 28.35 grams) of down occupies 800 cubic inches of space. With this fill power, the same amount of down can trap a larger volume of air, providing insulation and heat retention. It is typically used for cold climates ranging from -20°C to -5°C, offering an unparalleled warmth-to-weight ratio and excellent insulation without excessive bulk.")
  })
  $(".bgIcon3").click(function(){
    $(".bgIcon3").removeClass("op2");
    $(".bgIcon3").addClass("op1");
    $(".bgIcon1").removeClass("op1");
    $(".bgIcon2").removeClass("op1");
    $(".bgIcon1").addClass("op2");
    $(".bgIcon2").addClass("op2");
    $(".bigText").text("The fluffiness (FP) is crucial for judging a down jacket's warmth, and higher FP indicates superior quality. Achieving 900FP means an ounce (approx. 28.35g) of down fills 900 cubic inches, trapping a larger air layer for insulation with the same filling amount. Commonly used in outdoor gear for extreme temperatures ranging from -20℃ to -50℃, it offers lightweight yet effective warmth protection.")
  }) 
  $(".bottomIcon1").click(function(){
    $(".bottomIcon1").removeClass("op3");
    $(".bottomIcon1").addClass("op1");
    $(".bottomIcon2").removeClass("op1");
    $(".bottomIcon3").removeClass("op1");
    $(".bottomIcon4").removeClass("op1");
    $(".bottomIcon2").addClass("op3");
    $(".bottomIcon3").addClass("op3");
    $(".bottomIcon4").addClass("op3");
    $(".bigText2").text("Wool is a dynamic fiber that can respond dynamically to changes in body temperature, providing a comfortable feeling. Its natural crimp allows it to lock in air, creating an insulating layer that isolates the skin from cold environments and offers warmth. Additionally, wool has the ability to adapt to surrounding humidity levels and regulate internal moisture content. It can absorb and release moisture, regulating the air humidity inside the clothing and acting as a buffer in temperature regulation, maintaining a dry and comfortable microclimate on the skin.")
  }) 
  $(".bottomIcon2").click(function(){
    $(".bottomIcon2").removeClass("op3");
    $(".bottomIcon2").addClass("op1");
    $(".bottomIcon1").removeClass("op1");
    $(".bottomIcon3").removeClass("op1");
    $(".bottomIcon4").removeClass("op1");
    $(".bottomIcon1").addClass("op3");
    $(".bottomIcon3").addClass("op3");
    $(".bottomIcon4").addClass("op3");
    $(".bigText2").text("Sweat absorption into the fabric can lead to bacterial growth and odor, but fabrics treated with antimicrobial finishes can effectively inhibit and eliminate bacteria, eliminating odors caused by bacterial growth.")
  }) 
  $(".bottomIcon3").click(function(){
    $(".bottomIcon3").removeClass("op3");
    $(".bottomIcon3").addClass("op1");
    $(".bottomIcon1").removeClass("op1");
    $(".bottomIcon2").removeClass("op1");
    $(".bottomIcon4").removeClass("op1");
    $(".bottomIcon1").addClass("op3");
    $(".bottomIcon2").addClass("op3");
    $(".bottomIcon4").addClass("op3");
    $(".bigText2").text("Renewable natural fibers are known for their durability, softness, moisture-wicking, breathability, and elastic comfort. They also possess natural antibacterial and deodorizing properties, making them one of the most popular textile materials globally.")
  }) 
  $(".bottomIcon4").click(function(){
    $(".bottomIcon4").removeClass("op3");
    $(".bottomIcon4").addClass("op1");
    $(".bottomIcon1").removeClass("op1");
    $(".bottomIcon2").removeClass("op1");
    $(".bottomIcon3").removeClass("op1");
    $(".bottomIcon1").addClass("op3");
    $(".bottomIcon2").addClass("op3");
    $(".bottomIcon3").addClass("op3");
    $(".bigText2").text("Enhancing the fabric's breathability effect involves absorbing water vapor and promoting its evaporation. It rapidly transfers sweat vapor emitted by the body to the outside of the fabric, preventing heat loss due to condensation of sweat and reducing discomfort from sweat accumulation, thus maintaining a dry and comfortable experience.")
  }) 

  $(".m-bgIcon1").click(function(){
    $(".m-bgIcon1").removeClass("op2");
    $(".m-bgIcon1").addClass("op1");
    $(".m-bgIcon2").removeClass("op1");
    $(".m-bgIcon3").removeClass("op1");
    $(".m-bgIcon2").addClass("op2");
    $(".m-bgIcon3").addClass("op2");
    $(".m-bigText").text("Fill Power (FP) is a key measure of the insulating performance of down. The higher the Fill Power, the better the quality of the down jacket. A Fill Power of 700FP indicates that one ounce (approximately 28.35 grams) of down occupies a space of 700 cubic inches. With the same amount of filling, it can fix a larger volume of air for insulation and heat retention. It is generally used for cold climates ranging from 0 to -10°C, offering an unrivaled warmth-to-weight ratio. It is suitable for extremely cold weather and outdoor activities such as skiing and mountaineering.")
  })
  $(".m-bgIcon2").click(function(){
    $(".m-bgIcon2").removeClass("op2");
    $(".m-bgIcon2").addClass("op1");
    $(".m-bgIcon1").removeClass("op1");
    $(".m-bgIcon3").removeClass("op1");
    $(".m-bgIcon1").addClass("op2");
    $(".m-bgIcon3").addClass("op2");
    $(".m-bigText").text("Fill Power (FP) is a crucial measure of the insulating capability of down. The higher the Fill Power, the better the quality of the down jacket. An 800FP rating means that one ounce (approximately 28.35 grams) of down occupies 800 cubic inches of space. With this fill power, the same amount of down can trap a larger volume of air, providing insulation and heat retention. It is typically used for cold climates ranging from -20°C to -5°C, offering an unparalleled warmth-to-weight ratio and excellent insulation without excessive bulk.")
  })
  $(".m-bgIcon3").click(function(){
    $(".m-bgIcon3").removeClass("op2");
    $(".m-bgIcon3").addClass("op1");
    $(".m-bgIcon1").removeClass("op1");
    $(".m-bgIcon2").removeClass("op1");
    $(".m-bgIcon1").addClass("op2");
    $(".m-bgIcon2").addClass("op2");
    $(".m-bigText").text("The fluffiness (FP) is crucial for judging a down jacket's warmth, and higher FP indicates superior quality. Achieving 900FP means an ounce (approx. 28.35g) of down fills 900 cubic inches, trapping a larger air layer for insulation with the same filling amount. Commonly used in outdoor gear for extreme temperatures ranging from -20℃ to -50℃, it offers lightweight yet effective warmth protection.")
  }) 

  $(".m-bottomIcon1").click(function(){
    $(".m-bottomIcon1").removeClass("op3");
    $(".m-bottomIcon1").addClass("op1");
    $(".m-bottomIcon2").removeClass("op1");
    $(".m-bottomIcon3").removeClass("op1");
    $(".m-bottomIcon4").removeClass("op1");
    $(".m-bottomIcon2").addClass("op3");
    $(".m-bottomIcon3").addClass("op3");
    $(".m-bottomIcon4").addClass("op3");
    $(".m-bigText2").text("Wool is a dynamic fiber that can respond dynamically to changes in body temperature, providing a comfortable feeling. Its natural crimp allows it to lock in air, creating an insulating layer that isolates the skin from cold environments and offers warmth. Additionally, wool has the ability to adapt to surrounding humidity levels and regulate internal moisture content. It can absorb and release moisture, regulating the air humidity inside the clothing and acting as a buffer in temperature regulation, maintaining a dry and comfortable microclimate on the skin.")
  }) 
  $(".m-bottomIcon2").click(function(){
    $(".m-bottomIcon2").removeClass("op3");
    $(".m-bottomIcon2").addClass("op1");
    $(".m-bottomIcon1").removeClass("op1");
    $(".m-bottomIcon3").removeClass("op1");
    $(".m-bottomIcon4").removeClass("op1");
    $(".m-bottomIcon1").addClass("op3");
    $(".m-bottomIcon3").addClass("op3");
    $(".m-bottomIcon4").addClass("op3");
    $(".m-bigText2").text("Sweat absorption into the fabric can lead to bacterial growth and odor, but fabrics treated with antimicrobial finishes can effectively inhibit and eliminate bacteria, eliminating odors caused by bacterial growth.")
  }) 
  $(".m-bottomIcon3").click(function(){
    $(".m-bottomIcon3").removeClass("op3");
    $(".m-bottomIcon3").addClass("op1");
    $(".m-bottomIcon1").removeClass("op1");
    $(".m-bottomIcon2").removeClass("op1");
    $(".m-bottomIcon4").removeClass("op1");
    $(".m-bottomIcon1").addClass("op3");
    $(".m-bottomIcon2").addClass("op3");
    $(".m-bottomIcon4").addClass("op3");
    $(".m-bigText2").text("Renewable natural fibers are known for their durability, softness, moisture-wicking, breathability, and elastic comfort. They also possess natural antibacterial and deodorizing properties, making them one of the most popular textile materials globally.")
  }) 
  $(".m-bottomIcon4").click(function(){
    $(".m-bottomIcon4").removeClass("op3");
    $(".m-bottomIcon4").addClass("op1");
    $(".m-bottomIcon1").removeClass("op1");
    $(".m-bottomIcon2").removeClass("op1");
    $(".m-bottomIcon3").removeClass("op1");
    $(".m-bottomIcon1").addClass("op3");
    $(".m-bottomIcon2").addClass("op3");
    $(".m-bottomIcon3").addClass("op3");
    $(".m-bigText2").text("Enhancing the fabric's breathability effect involves absorbing water vapor and promoting its evaporation. It rapidly transfers sweat vapor emitted by the body to the outside of the fabric, preventing heat loss due to condensation of sweat and reducing discomfort from sweat accumulation, thus maintaining a dry and comfortable experience.")
  }) 